var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 8.16667C17.5007 7.71226 17.5007 6.55054 17.5007 5.49995C17.5007 4.39539 16.6052 3.5 15.5007 3.5H12.5007C11.3961 3.5 10.5007 4.39539 10.5007 5.49995C10.5007 6.55054 10.5007 7.71226 10.5007 8.16667H8.16732M5.83398 8.16667H8.16732M22.1673 8.16667H19.834M19.834 8.16667V22.5C19.834 23.6046 18.9386 24.5 17.834 24.5H10.1673C9.06275 24.5 8.16732 23.6046 8.16732 22.5V8.16667M19.834 8.16667H8.16732",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.8f12384842c515d5960cd483c076f8f8.svg";
export { ForwardRef as ReactComponent };